import { render, staticRenderFns } from "./TienDanPhong.vue?vue&type=template&id=1c70ca16"
import script from "./TienDanPhong.vue?vue&type=script&lang=js"
export * from "./TienDanPhong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports